/** Tag unlabeled opening fences as Python so Shiki and Monaco can highlight them. Never rewrite closers. */
export function defaultUnlabeledFencesToPython(markdown: string): string {
  const lines = markdown.split('\n')
  let inFence = false

  return lines.map((line) => {
    const trimmed = line.trimStart()
    if (!trimmed.startsWith('```')) return line
    if (inFence) {
      inFence = false
      return line
    }
    inFence = true
    const info = trimmed.slice(3).trim()
    if (info !== '') return line
    const indent = line.match(/^\s*/)?.[0] ?? ''
    return `${indent}\`\`\`python`
  }).join('\n')
}

export function checkMarkdown(message: string): string {
  const blocks = message.split('```');

    for (let i = 0; i < blocks.length; i++) {
      if (!blocks[i].endsWith('\n')) {
        blocks[i] += '\n';
      } 
      if (blocks[i].startsWith('\n') || blocks[i].startsWith('python\n')) {
        continue;
      }
      if (blocks[i].startsWith('python')) {
        blocks[i] = blocks[i].replace('python', 'python\n ');
      } else {
        blocks[i] = '\n' + blocks[i];
      }
      if (!blocks[i].endsWith('\n')) {
        blocks[i] += '\n';
      }
    }
    return blocks.join('```');
}

export function prepareMarkdownForPreview(message: string): string {
  return checkMarkdown(defaultUnlabeledFencesToPython(message))
}